import React, { useCallback, useEffect, useMemo, useState } from "react";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
import CustomSwitch from "../../components/Elements/CustomSwitch/CustomSwitch";
import CardsBorder from "../../components/Cards/CardsBorder";
import SearchBar from "../../components/Elements/Search/SearchBar";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import { Button } from "antd";
import { Tables } from "../../components/Elements/Tables/Tables";
import { useNavigate } from "react-router-dom";
import NewOnBoarding from "./NewOnBoarding/NewOnBoarding";
import CustomerFilter from "./CustomerDetailPage/Roles/DIalogBoxes/CustomerFilter";
import SuccessDailogBox from "../../components/Elements/DailogBox/SuccessDailogBox";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import { getAllClients } from "../../redux/customer/customerSlice";
import { useSelector, useDispatch } from "react-redux";
import { useRef } from "react";
import { updateClientStatus } from "../../redux/customer/customerSlice";
const Customer = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [searchTerm, setSearchTerm] = useState("");
  const debounceTimer = useRef(null);
  const [createNewOnboarding, setCreateNewOnboarding] = useState(false);
  const [filteropen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [popup, setPopup] = useState({
    visible: false,
    type: "success", // success | warning | error
    title: "",
    message: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const DEBOUNCE_DELAY = 500;
  //---------Getting data from redux-----
  const { allCustomers, totalCustomers, limit, customerLoading } = useSelector(
    (state) => state.customer,
  );

  // ------Fetch client----------
  useEffect(() => {
    dispatch(
      getAllClients({
        pageNo: currentPage,
        limit: pageSize,
        sort: sortOrder,
        search: searchTerm,
        filter: filterData,
      }),
    );
  }, [dispatch, currentPage, pageSize, sortOrder, searchTerm, filterData]);

  // ─── Debounced Search ─────────────────────────────────────────────────────
  const handleSearchChange = useCallback((value) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setSearchTerm(value);
      setCurrentPage(1); // reset pagination when searching
    }, DEBOUNCE_DELAY);
  }, []);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Customer Name", key: "customerName" },
      { label: "Group Name", key: "groupName" },
      { label: "User ID", key: "userId" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });

    // Optional: auto-close after 3 seconds
    setTimeout(() => {
      setPopup((prev) => ({ ...prev, visible: false }));
    }, 3000);
  };

  //--------------Get Data----------
  const formattedData = useMemo(() => {
    return allCustomers.map((row, index) => ({
      ...row,
      
      serial: (
        <div className="text-center font-light">
          {(currentPage - 1) * pageSize + index + 1}
        </div>
      ),
      customerName: (
        <div className="text-center whitespace-normal break-words max-w-[220px] mx-auto">
          {row.organization?.name || row.name}
        </div>
      ),
      groupName: <div className="text-center font-light">{row.groupName}</div>,
      userId: <div className="text-center font-light">{row.userId}</div>,
      status: <Badge text={row.status} />,
      action: (
        <div className="flex gap-2 justify-center items-center">
          <GreenEye
            onClick={() => {
              navigate(`/customer/customer-page/${row._id}`, {
                state: {
                  userName: row.organization?.name || row.name,
                  customerId: row._id,
                  orgStructureMode: row.orgStructureMode
                },
              });
            }}
          />
          <CustomSwitch
            checked={row.status === "Active"}
            onChange={(checked) => handleStatusToggle(row._id, checked)}
          />
        </div>
      ),
    }));
  }, [allCustomers, navigate, currentPage, pageSize]);

  //--------------Handle Toggle------
  const handleStatusToggle = async (id, checked) => {
    try {
      await dispatch(
        updateClientStatus({
          id,
          data: { status: checked ? "Active" : "Inactive" },
        }),
      ).unwrap();

      showPopup(
        "success",
        "Status Updated",
        `Customer has been ${checked ? "activated" : "deactivated"} successfully`,
      );
    } catch (err) {
      console.log("Status update failed", err);

      showPopup(
        "error",
        "Status Update Failed",
        err || "Unable to update customer status",
      );
    }
  };

  //---PAGE CHANGE------------------
  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt",
    );
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
    sessionStorage.setItem("customerPage", page.toString());
  }, []);

  useEffect(() => {
    const savedPage = sessionStorage.getItem("customerPage");
    if (savedPage) {
      setCurrentPage(parseInt(savedPage, 10));
    }
  }, []);

  return (
    <div style={{ padding: "40px" }}>
      <div>
        {!createNewOnboarding && (
          <div>
            <div>
              <div
                className="flex justify-end  text-xs"
                style={{ fontFamily: "Calibri" }}
              >
                
                <p>Home</p>
                <span> / </span>
                <TextStyles color="gradient"> Customer</TextStyles>
              </div>
              <div className="flex items-center  gap-2 text-xl  font-bold">
                {/* <Back /> */}
                <div className="pt-4 px-2">
                  <TextStyles color="gradient"> Customer</TextStyles>
                </div>
              </div>
            </div>
            <CardsBorder>
              <div className="flex justify-between mb-4 px-6">
                <div className="flex gap-4">
                  <div
                    style={{
                      background: "#B6D4D933",
                      height: "40px",
                    }}
                    className="px-4   border border-gray-300 rounded-md text-gray-400 text-base font-light"
                  >
                    <p
                      style={{
                        fontFamily: "Calibri",
                        fontWeight: "300",
                        fontSize: "16px",
                        lineHeight: "24px",
                        letterSpacing: "0%",
                      }}
                      className="pt-2"
                    >
                      TOTAL CUSTOMERS {formattedData.length}
                    </p>
                  </div>
                  <SearchBar width="300px" onSearch={handleSearchChange} />
                </div>
                <div className="flex gap-4">
                  <CustomButton
                    buttonType="primary"
                    variant="ok"
                    buttonText="+NEW ONBOARDING"
                    className={"py-6 text-xs font-medium"}
                    onClick={async () => {
                      // setCreateNewOnboarding(true);
                      navigate("/customer/new-onboarding");
                    }}
                  />
                  <Button
                    onClick={() => setFilterOpen(true)}
                    type="secondary"
                    style={{
                      background: "#B6D4D9",
                      border: "solid 1px #06513D",
                    }}
                    className="text-[14px] !bg-[#E6EDEB] hover:!bg-[#F8F8F8]  text-[#06513D] font-normal px-4 py-6"
                  >
                    <FilterIcon /> FILTER
                  </Button>
                </div>
              </div>
              <Tables
                data={formattedData}
                headers={headers}
                pageSize={limit}
                total={totalCustomers}
                current={currentPage}
                onChange={handlePageChange}
                onSort={handleSort}
                loading={customerLoading}
              />
            </CardsBorder>{" "}
          </div>
        )}
      </div>
      {/* {createNewOnboarding && (
          <div>
            <CardsBorder>
              <NewOnBoarding />
            </CardsBorder>
          </div>
        )} */}
      {filteropen && (
        <CustomerFilter
          onOpen={filteropen}
          onClose={() => setFilterOpen(false)}
          setFilterData={setFilterData}
          initialStatus={filterData}
        />
      )}

      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default Customer;
